<template>
    <NuxtLink :to="resultPath" class="result">
        <h2 class="result-title">
            <template v-if="titleMatches">
                {{ highlightedTitle.first }}<span class="highlight">{{ highlightedTitle.keyword }}</span>{{ highlightedTitle.last }}
            </template>
            <template v-else>
                {{ resultTitle }}
            </template>
        </h2>
        <p v-if="resultDescription" class="result-description">
            <template v-if="descriptionMatches">
                {{ highlightedDescription.first }}<span class="highlight">{{ highlightedDescription.keyword }}</span>{{ highlightedDescription.last }}
            </template>
            <template v-else>
                {{ resultDescription }}
            </template>
        </p>
        <div class="result-details">
            <span class="result-tag">{{ $t(`search.${result.content.contentType}`) }}</span>
            <span class="result-path">{{ resultPath }}</span>
        </div>
    </Nuxtlink>
</template>

<script setup>
import { computed } from 'vue';

const { result, prompt } = defineProps({
    result: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    prompt: {
        type: String,
        required: false,
        default: '',
    },
});

const { $i18n } = useNuxtApp();

const promptRegex = computed(() => new RegExp(prompt, 'gi'));
const resultPath = computed(() => `/${result.localizedPagePaths[$i18n.locale.value]}`);

const resultTitle = computed(() => result?.content?.title ?? result?.content?.station?.name ?? resultPath.value);
const titleMatches = computed(() => promptRegex.value.test(resultTitle.value));
const highlightedTitle = computed(() => {
    const [first, last] = resultTitle.value.split(promptRegex.value);

    return { first, keyword: prompt, last };
});

const resultDescription = computed(() => result.content.description || '');
const descriptionMatches = computed(() => promptRegex.value.test(resultDescription.value));
const highlightedDescription = computed(() => {
    const [first, last] = resultDescription.value.split(promptRegex.value);

    return { first, keyword: prompt, last };
});

</script>

<style scoped>
.result {
  border-bottom: 1px solid var(--color-base-grey-200);
  padding: 1rem;
}

.result-title {
  font-size: 1rem;
  font-weight: 600;
}

.result-description {
  margin: 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 400;
}

.highlight {
  background-color: var(--color-primary-500);
  border-radius: 0.125rem;
  font-weight: 700;
}

.result-details {
  margin-top: 1rem;
}
.result-details .result-tag {
  padding: 0.25rem 0.5rem;
  margin: 0.5rem;
  margin-left: 0;
  border-radius: 0.5rem;
  background-color: var(--color-base-grey-200);
  color: var(--color-base-black);
}
.result-details .result-path {
  color: var(--color-base-grey-600);
}

@media (max-width: 1199px) {
  .result {
    padding: 1rem 0;
    margin: 0 0.25rem;
  }
}
</style>
